var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLagout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2 6.447C2 3.996 4.03024 2 6.52453 2H11.4856C13.9748 2 16 3.99 16 6.437V17.553C16 20.005 13.9698 22 11.4744 22H6.51537C4.02515 22 2 20.01 2 17.563V16.623V6.447Z",
    fill: "#CC5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7773 11.4548L18.9315 8.5458C18.6373 8.2458 18.164 8.2458 17.8709 8.5478C17.5787 8.8498 17.5797 9.3368 17.8728 9.6368L19.4321 11.2298H17.9371H9.54679C9.13288 11.2298 8.79688 11.5748 8.79688 11.9998C8.79688 12.4258 9.13288 12.7698 9.54679 12.7698H19.4321L17.8728 14.3628C17.5797 14.6628 17.5787 15.1498 17.8709 15.4518C18.0179 15.6028 18.2098 15.6788 18.4026 15.6788C18.5935 15.6788 18.7854 15.6028 18.9315 15.4538L21.7773 12.5458C21.9185 12.4008 21.9983 12.2048 21.9983 11.9998C21.9983 11.7958 21.9185 11.5998 21.7773 11.4548Z",
    fill: "#CC5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLagout);
export default __webpack_public_path__ + "static/media/lagout.0b01909f02f249642a9d534d59cc2d42.svg";
export { ForwardRef as ReactComponent };